<template>
  <NavBarSelect>
    <template #activator>
      {{ $tt('nav.visa_country_select.label') }}
    </template>
    <AppListItem
      v-for="country in $branch.visaCountries"
      :key="country"
      :to="getVisaCountryPath(country)"
    >
      <template #prepend>
        <CountryFlag :code="getVisaCountryIsoCode(country)" />
      </template>
      <template #title>
        {{ $tt(`nav.visa_country_select.option_${country}`) }}
      </template>
    </AppListItem>
  </NavBarSelect>
</template>

<script setup lang="ts">
import { getVisaCountryIsoCode, getVisaCountryPath } from '~/helpers/visa-country';
</script>

<style scoped>
.nav-bar-list-item { 
  min-height: var(--space-7);
}
</style>